import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { Icon } from 'antd';
import Ink from 'react-ink';

import './sidenav.css';

import HeaderLogo from '../common/headerlogo/HeaderLogo';
import UserModal from '../usermanagement/modal/UserModal';

import profile from '../static/profile.png';

import {
	userLogout,
	userSideNav
} from '../../modules/user';

class SideNav extends Component {
	constructor(props) {
		super(props);
		this.state = {
			userModal: false
		}
	}

	toggleUserModal = () => {
		const { userModal } = this.state;
		this.setState({ userModal: !userModal });
	}

	onLogout() {
		this.props.userLogout();
		this.props.history.push('/login');
	}

	toggleSideNav = () => {
		const { userNav } = this.props;
		this.props.userSideNav(userNav);
	}

	render() {
		const { userModal } = this.state;
		const { userProfile } = this.props;
		const { location } = this.props;

		const userRole = (userProfile.user) ? userProfile.user.role : null;
		const isSuperAdmin = userProfile.user && userProfile.user.email === 'superadmin@sds.com';
		const isSchool = userProfile.user && userProfile.user.role === 'user';
		const classSideNav = (this.props.userNav) ? 'sideNavWrapper sideNavWrapperForce' : 'sideNavWrapper';

		const toggleSideNav = (this.props.userNav) ? <div className="toggleSideNav"><a onClick={() => this.toggleSideNav()}><Icon type="menu-fold" /></a></div> : "";

		if (this.props.userAuthenticated && userProfile.user) {
			return (
				<div className={classSideNav}>
					{toggleSideNav}
					<HeaderLogo size="small" />
					<div className="profileHolder">
						<img src={profile} alt="profile default" />
						<div className="details">
							<a className="username">{userProfile.user.email.split('@')[0]}</a>
							<p className="type">
								{userProfile.user.role}
								<a onClick={() => this.onLogout()}>signout</a>
							</p>
						</div>
					</div>
					<ul className="navHolder">
						{
							(userRole === 'admin') ?
								<div>
									{/* <li className={(location.pathname === '/') ? 'active' : ''}><Link to="/"><Ink /><Icon type="home" /> 主頁</Link></li> */}
									{
										(userProfile.user && userProfile.user.role === 'admin' && userProfile.user.name == "Admin") &&
										<li className={(location.pathname === '/schoollist') ? 'active' : ''}><Link to="/schoollist"><Ink /><Icon type="ordered-list" /> 學校名單/資訊</Link></li>
									}
									{
										(userProfile.user && userProfile.user.role === 'admin' && userProfile.user.name == "Admin") &&
										<li className={(location.pathname === '/schoolquota') ? 'active' : ''}><Link to="/schoolquota" ><Ink /><Icon type="pie-chart" /> 學校年度問卷配額</Link></li>
									}
									<li className={(location.pathname === '/class') ? 'active' : ''}><Link to="/class"><Ink /><Icon type="usergroup-add" /> 新增班別/學生</Link></li>
									<li className={(location.pathname === '/occupation') ? 'active' : ''}><Link to="/occupation"><Ink /><Icon type="folder-open" /> 職業名單</Link></li>
									<li className={(location.pathname === '/usermanagement') ? 'active' : ''}><Link to="/usermanagement"><Ink /><Icon type="user" /> 新增學校帳戶</Link></li>
									<li className={(location.pathname === '/data') ? 'active' : ''}><Link to="/data"><Ink /><Icon type="bar-chart" /> 大數據分析</Link></li>
									<li className={(location.pathname === '/browser') ? 'active' : ''}><Link to="/browser"><Ink /><Icon type="desktop" /> 瀏覽數據</Link></li>
									{/* <li className={(location.pathname === '/display') ? 'active' : ''}><Link to="/display"><Ink /><Icon type="export" /> 匯出</Link></li> */}
									{
										isSuperAdmin &&
										<li className={(location.pathname === '/translation') ? 'active' : ''}><Link to="/translation"><Ink /><Icon type="smile" /> Translation Table</Link></li>
									}
								</div> :
								<div>
									<li className={(location.pathname === '/schoolquota') ? 'active' : ''}><Link to="/schoolquota" ><Ink /><Icon type="pie-chart" /> 學校年度問卷配額</Link></li>
									<li className={(location.pathname === '/class') ? 'active' : ''}><Link to="/class"><Ink /><Icon type="usergroup-add" /> 班別/學生</Link></li>
								</div>
						}
					</ul>

					<UserModal
						show={userModal}
						toggleAddModal={this.toggleUserModal.bind(this)}
						data={userProfile.user}
					/>
					<span className="copyright">Copyright &copy; Hong Kong Family Welfare Society All Rights Reserved</span>
				</div>
			);
		}

		return (<div>&nbsp;</div>);
	}

}

const mapStateToProps = state => ({
	router: state.router,
	userAuthenticated: state.user.userAuthenticated,
	userProfile: state.user.userProfile,
	userNav: state.user.userNav
});

const mapDispatchToProps = dispatch =>
	bindActionCreators(
		{
			userLogout,
			userSideNav
		},
		dispatch
	);

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SideNav));
